import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { getApiToken, isApiTokenLegacy, useAuth } from '../context/AuthContext';
import { deleteTokens } from '../api/jwtAuth/jwtAuthApi';

export const useLogout = () => {
  const { logout } = useAuth();

  const history = useHistory();

  return useCallback(() => {
    const apiToken = getApiToken();
    if (isApiTokenLegacy(apiToken)) {
      logout();
      history.push('/');
      return;
    }
    // we need it to remove refreshToken and accessToken from cookies
    deleteTokens().then(() => {
      logout();
      history.push('/');
    });
  }, [logout, history]);
};
